import { useCallback, useEffect, useMemo, useState } from "react";
import { fetchAllRegions } from "services/services.congressman";
import { getFormattedOptions } from "utility/helpers";

const useRegions = () => {
  const [regions, setRegions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    fetchAllRegions({
      callback: (data) => {
        setRegions(data);
        setIsLoading(false);
      },
    });
  }, []);

  const options = useMemo(() => {
    return getFormattedOptions("name", regions);
  }, [regions]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: regions,
    isLoading,
    refetch,
    options,
  };
};

export default useRegions;
